import { render, staticRenderFns } from "./table-receivers.vue?vue&type=template&id=2660542d&scoped=true&"
import script from "./table-receivers.vue?vue&type=script&lang=js&"
export * from "./table-receivers.vue?vue&type=script&lang=js&"
import style0 from "./table-receivers.vue?vue&type=style&index=0&id=2660542d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2660542d",
  null
  
)

export default component.exports